import {SearchModelBase} from './SearchModelBase';
import * as XCol from '../../framework.core/XExportColumn';

export class MTTaskListItem extends SearchModelBase {
    asigned: string = '';
    dueDate: string | null = null;
    fromDueDate: string | null = null;
    toDueDate: string | null = null;
    createdAt: string | null = null;
    fromCreatedAt: string | null = null;
    toCreatedAt: string | null = null;
    createdBy: string = '';
    refNo: string = '';
    title: string = '';
    contents: string = '';
    tbName: string = '';
    tbId: number = 0;
    id: number = 0;
    opType: string = '';
    bltbId: number = 0;
    bltbName: string = '';
    updatedAt: string | null = null;
    fromUpdatedAt: string | null = null;
    toUpdatedAt: string | null = null;
    updatedBy: string = '';
    mblNo: string = '';
    
    private static ExportCollection: XCol.XExportColumn[] = [
      XCol.Create({ col: 0, text: 'Status', width: 50, dataIndex: 'taskStatus'}),
      XCol.Create({ col: 1, text: 'Title', width: 200, dataIndex: 'title'}),
      XCol.Create({ col: 2, text: 'Task/Memo', width: 350, dataIndex: 'contents'}),
      XCol.Create({ col: 3, text: 'Type', width: 70, dataIndex: 'opType'}),
      XCol.Create({ col: 4, text: 'Related #', width: 120, dataIndex: 'refNo'}),
      XCol.Create({ col: 5, text: 'Assigned', width: 90, dataIndex: 'assigned'}),
      XCol.Create({ col: 6, text: 'Remind Date', width: 120, dataIndex: 'dueDate',type: XCol.XCellType.DateTime,}),
      XCol.Create({ col: 7, text: 'Update Date', width: 95, dataIndex: 'updatedAt',type: XCol.XCellType.DateTime,}),
      XCol.Create({ col: 8, text: 'Update By', width: 90, dataIndex: 'updatedBy'}),
      XCol.Create({ col: 9, text: 'Create Date', width: 95, dataIndex: 'createdAt',type: XCol.XCellType.DateTime,}),
      XCol.Create({ col: 10, text: 'Create By', width: 90, dataIndex: 'createdBy'}),
    ];


    public static getExportCollection(): XCol.XExportColumn[] {
      return this.ExportCollection;
    };
    
    public static OrderBy = { orderBy: MTTaskListItem.prototype.createdAt, orderByAscending: false };

    public static formatData(data: MTTaskListItem[]) {
        return data.map((d: MTTaskListItem) => ({
          ...d,
        }));
    }

    public static MapSearchFields:{[key: string]: {[key: string]: string}} = {
      createdAt: {from: 'fromCreatedAt', to: 'toCreatedAt'},
      dueDate: {from: 'fromDueDate', to: 'toDueDate'},
      updatedAt: {from: 'fromUpdatedAt', to: 'toUpdatedAt'},
    }
}
